<template>
  <div class="wrapper">
    <!--头部-->
    <page-head :title="title" :show-back="true"></page-head>
    <div class="table-tabs">
      <form-info :title="'基本信息'" class="mb-1">
        <div slot="btn">
          <Button class="bkcc-btn btn" @click="editGrid">编辑</Button>
        </div>

        <div slot="content">
          <Form>
            <row :gutter="80">
              <i-col span="8">
                <FormItem label="网格地图图片">
                  <el-image
                    v-if="info.coverPicUrl"
                    class="headPicUrl"
                    :preview-src-list="[info.coverPicUrl]"
                    :src="info.coverPicUrl"
                  />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="网格名称">
                  <div class="detail">{{info.gridName}}</div>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="网格级别">
                  <div class="detail">{{info.levelName}}</div>
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="网格描述">
                  <div class="detail">{{info.remark}}</div>
                </FormItem>
              </i-col>
            </row>
          </Form>
        </div>
      </form-info>

      <form-info :title="'网格长信息'" class="mb-1">
        <div slot="btn">
          <Button class="bkcc-btn btn" @click="addGridUser">添加网格长</Button>
        </div>
        <div slot="content">
          <div class="table-data">
            <i-table
              :columns="tableHeader"
              :border="true"
              :loading="isTableLoading"
              :data="tableData"
              stripe
              ref="table"
            >
              <template slot-scope="{ row, index }" slot="action">
                <span @click="handleClickDetail(row,'edit')" class="action">[编辑]</span>
                <span @click="handleClickDetail(row,'del')" class="action">[删除]</span>
              </template>
            </i-table>
            <div class="page">
              <page :total="total" :current="pageNum" @on-change="pageChange" show-total />
            </div>
          </div>
        </div>
      </form-info>
    </div>
    <Modal
      v-model="editGridBtn"
      title="编辑网格"
      :mask-closable="false"
      width="660"
      class-name="vertical-center-modal"
    >
      <!--@on-change="handleClick"-->
      <div class="tr box">
        <div class="tr_title ml-10">网格地图图片</div>
        <upload-img
          :imgArr="imgArr"
          :imgNumber="imgNumber"
          :fixedNumber="fixedNumber"
          :imgHeight="148"
          :imgWidth="238"
          @saveImg="saveImg"
          @delPic="delPic"
        >
          <div class="uploadbox">
            <i class="iconfont icon-shangchuan1"></i>
            <p class="fengmian">请上传图片</p>
            <!-- <p class="tips">注意图片尺寸为：2:1</p> -->
          </div>
        </upload-img>
      </div>
      <div class="tr box">
        <div class="tr_title">网格名称</div>
        <Input v-model="gridName" type="text" placeholder="请输入网格名称" style="width: 90%" />
      </div>
      <div class="tr box">
        <div class="tr_title">网格级别</div>
        <Select
          v-model="levelId"
          style="width:560px"
          placeholder="请选择网格级别"
          size="large"
          @on-change="getSubGridLevel"
        >
          <Option v-for="(item, index) in levelList" :value="item.id" :key="index">{{ item.name }}</Option>
        </Select>
      </div>
      <div class="tr box">
        <div class="tr_title">上级网格</div>
        <Select v-model="parentId" style="width:560px" placeholder="请选择上级网格" size="large">
          <Option
            v-for="(item, index) in subLevelList"
            :value="item.id"
            :key="index"
          >{{ item.name }}</Option>
        </Select>
      </div>
      <div class="tr box">
        <div class="tr_title">网格描述</div>
        <Input v-model="remark" type="textarea" :rows="4" placeholder="请输入网格描述" style="width: 90%" />
      </div>
      <div slot="footer">
        <Button style="margin-right:10px" @click="editGridBtn = false">取消</Button>
        <Button type="primary" @click="editGridSubmit">确定</Button>
      </div>
    </Modal>
    <add-grid-member
      :showModal="editGridUserBtn"
      :passLeader="gridUser"
      :gridId="$route.query.id"
      @quxiao="quxiao"
      @addMember="addMember"
    ></add-grid-member>
    <Modal v-model="delBtn" title="删除网格长" width="660px">
      <div>
        您确定要删除
        <span class="red">{{info.gridName}}</span>下的网格长
        <span class="red">{{delGridUserName}}</span>么？
      </div>
      <div slot="footer">
        <Button style="margin-right:10px" @click="delBtn = false">取消</Button>
        <Button type="primary" @click="onDelete">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import formInfo from "../../userManager/components/formInfo";
import uploadImg from "../../../components/uploadImg";
import addGridMember from "../../miniCommunity/components/addGridMember";
const TYPEMAP = {
  0: {
    isExcellent: "否",
  },
  1: {
    isExcellent: "是",
  },
};
export default {
  name: "gridDetail",
  components: {
    pageHead,
    formInfo,
    uploadImg,
    addGridMember,
  },
  data() {
    return {
      title: "网格名称",
      editGridBtn: false,
      editGridUserBtn: false,
      delBtn: false,
      gridUser: "",
      info: {},
      levelList: [],
      subLevelList: [],
      imgNumber: 1,
      imgArr: [],
      fixedNumber: [2, 1],
      gridName: "",
      delGridName: "",
      delGridUserName: "",
      delGridUserId: "",
      delId: "",
      levelId: "",
      parentId: "",
      coverPicUrl: "",
      remark: "",
      tableHeader: [
        {
          title: "序号",
          type: "index",
          //   width: 60,
          align: "center",
        },
        {
          title: "姓名",
          key: "userName",
        },
        {
          title: "电话号码",
          key: "phoneNO",
        },
        {
          title: "职称",
          key: "proTitle",
        },
        {
          title: "最美网格长",
          key: "isExcellent",
        },
        {
          title: "操作",
          slot: "action",
        },
      ],
      tableData: [],
      isTableLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
    };
  },
  computed: {},
  watch: {},
  methods: {
    editGrid() {
      this.editGridBtn = true;
      this.gridName = this.info.gridName;
      this.levelId = this.info.levelId;
      if (this.imgArr.length == 0) {
        this.imgArr.push({ path: this.info.coverPicUrl, id: 0 });
      }
      console.log(this.info.levelId, this.info.parentId);
      this.parentId = this.info.parentId;
      this.remark = this.info.remark;
    },
    editGridSubmit() {
      // 判断选中的企业
      if (!this.imgArr[0].path)
        return this.$Message.warning("未上传网格地图图片");
      if (!this.gridName) return this.$Message.warning("未输入网格名称");
      if (!this.levelId) return this.$Message.warning("未选择网格级别");
      if (this.levelId != 1 && !this.parentId)
        return this.$Message.warning("未选择上级网格");
      if (!this.remark) return this.$Message.warning("未输入网格描述");

      let url = this.urlobj.addGrid();
      let { id } = this.$route.query;
      let data = {
        id: id,
        coverPicUrl: this.imgArr[0].path,
        gridName: this.gridName,
        levelId: this.levelId,
        parentId: this.parentId,
        remark: this.remark,
      };
      console.log(data);
      this.$showLoading();
      this.$post(url, data)
        .then((res) => {
          if (!res.isSucceed) return this.$Message.error(res.message);
          this.$Message.success("添加成功");
          this.imgArr = [];
          this.gridName = "";
          this.levelId = "";
          this.parentId = "";
          this.remark = "";
          // 关闭弹窗
          this.editGridBtn = false;
          // 更新人员列表
          this.getDetail();
        })
        .finally(this.$hideLoading);
    },
    saveImg(data) {
      this.imgArr.splice(0, 1, data);
    },
    delPic(item) {
      this.imgArr.splice(item.index, 1);
    },
    getGridLevel() {
      let url = this.urlobj.gridLevel();
      this.$get(url)
        .then((res) => {
          console.log(res);
          if (res.isSucceed) {
            /* 如果有数据 */
            if (res.rows.length) {
              this.levelList = res.rows;
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getSubGridLevel(levelId) {
      console.log(levelId);
      let url = this.urlobj.gridList();
      if (levelId == 1) {
        this.subLevelList = [];
        this.parentId = "";
        return;
      }
      this.$post(url, {
        levelId: levelId - 1,
      })
        .then((res) => {
          console.log(res);
          if (res.isSucceed) {
            /* 如果有数据 */
            if (res.rows.length) {
              this.subLevelList = res.rows.map((item) => {
                return {
                  id: item.id,
                  name: item.gridName,
                };
              });
              console.log(this.subLevelList);
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getDetail() {
      let { id } = this.$route.query;
      let url = this.urlobj.getGridDetail(id);
      console.log(url);
      this.$get(url).then((res) => {
        if (res.isSucceed) {
          console.log(res);
          if (res.rows && res.rows[0]) {
            this.info = res.rows[0];
            this.getSubGridLevel(this.info.levelId);
          }
        }
      });
    },
    pageChange(val) {
      this.pageNum = val;
      this.getGridUserList();
    },
    getGridUserList() {
      let url = this.urlobj.getGridUserList();
      let { id } = this.$route.query;
      console.log(url);
      this.$post(url, {
        gridId: id,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.isSucceed) {
          console.log(res);
          if (res.rows) {
            let list = res.rows.map((item) => ({
              ...item,
              ...TYPEMAP[item.isExcellent != null ? +item.isExcellent : null],
            }));
            this.tableData = list;
            this.total = res.total;
            console.log(this.tableData);
          }
        }
      });
    },
    handleClickDetail(item, type) {
      if (type == "edit") {
        console.log(item);

        this.editGridUserBtn = true;
        this.gridUser = item;
      } else if (type == "del") {
        this.delBtn = true;
        console.log(item);
        this.delGridUserName = item.userName;
        this.delGridUserId = item.id;
      }
    },
    addGridUser() {
      this.editGridUserBtn = true;
      this.gridUser = {};
    },
    quxiao() {
      this.editGridUserBtn = false;
    },
    addMember(person) {
      this.editGridUserBtn = false;
      console.log(person);
      this.getGridUserList();
    },
    onDelete() {
      var url = this.urlobj.delGridUser(this.delGridUserId);
      this.$delete(url)
        .then((res) => {
          console.log(res);
          this.delBtn = false;
          if (res.isSucceed) {
            this.$Message.success("删除成功");
            this.getGridUserList();
          }
        })
        .catch((e) => {
          this.delBtn = false;
          this.$Message.error("删除失败");
        });
    },
  },
  created() {
    this.getDetail();
    this.getGridUserList();
    this.getGridLevel();
  },
};
</script>

<style scoped lang="less">
.mb-1 {
  margin-bottom: 10px;
}
.red {
  color: #d22c2c;
}
.detail {
  color: #666;
}
.headPicUrl {
  display: block;
  height: 80px;
  width: 80px;
  margin-bottom: 20px;
}
.tr {
  line-height: 36px;
  margin-bottom: 15px;
  .tr_title {
    margin-left: 20px;
    margin-right: 20px;
    width: 60px;
  }
  .ml-10 {
    margin-left: 0px;
    margin-right: 0px;
    width: 100px;
  }
}
.uploadbox {
  width: 200px;
  height: 148px;
  border: 1px dashed #ddd;
  text-align: center;
  margin-top: 12px;
  .icon-shangchuan1 {
    display: block;
    font-size: 37px;
    color: #e3e3e3;
    margin-top: 32px;
  }
  .fengmian {
    font-size: 14px;
    color: #666;
    margin-top: 10px;
  }
  .tips {
    font-size: 14px;
    color: #999;
  }
}
.table-tabs {
  max-width: 100%;
  padding-left: 24px;
  .table-data {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    min-height: calc(100vh - 450px);
    .page {
      width: 100%;
      margin-top: 10px;
      display: flex;
      justify-content: center;
    }
    .action {
      color: #5e6d94;
      cursor: pointer;
      margin-right: 10px;
    }
  }
}
</style>
